/**
 * this component represents the overview for all Castings.
 * Generally it just lists all active Castings and has a button to list old Castings.
 * NOTE: having most recent Castings on top would make sense and then 
 *          a list with all active castings grouped under customer
 */
import React, { useState, useEffect } from 'react';
import { getPools } from '../../../utils/api';
import CastingView from './CastingView'
import CreateCasting from './CreateCasting';
import SearchBar from '../../SeachBar';

const CastingUnit = () => {
    const [castings, setCastings] = useState([]); // State to store castings
    const [selectedCasting, setSelectedCasting] = useState(null); // State to store selected casting
    const [isCreatingCasting, setIsCreatingCasting] = useState(false); // State to toggle CreateCastingView

    //TODO: Castings fetchen, using pools as placeholder
    useEffect(() => {
        fetchPools();
    }, []);

    const fetchPools = async () => {
        try {
            const response = await getPools();
            setCastings(response.data || []);
        } catch (err) {
            console.error('Error fetching pools:', err);
        }
    };

    const handleCastingClick = (casting) => {
        setSelectedCasting(casting); // Set the selected pool
    };

    return (
        <div className="pool-list">
            <h1 className="title">Model Casting</h1>
            {isCreatingCasting ? (
                //hier müssen natürlich pools reingegeben werden, ich glaube create pool/casting muss sich die pools nochmal selber holen
                <CreateCasting onBack={() => { setIsCreatingCasting(false) }} pools={castings} />
            ) : selectedCasting ?
                (<CastingView selectedCasting={selectedCasting} setSelectedCasting={setSelectedCasting} castings={castings} />

                ) : (
                    <>
                        <SearchBar optionalInfos={
                            [<span key={"active"}>Active Castings: 6</span>]} />
                        <div style={{ textAlign: 'left' }}>
                            <button className="button" onClick={() => setIsCreatingCasting(true)}>New Casting</button>
                        </div>
                        <div className="table">
                            <div className="table-header">
                                <span className="header-cell">Casting Name</span>
                                <span className="header-cell">placeholder</span>
                                <span className="header-cell">placeholder</span>
                            </div>
                            {castings.map((casting, index) => (
                                <div
                                    key={index}
                                    className="table-row"
                                    onClick={() => { handleCastingClick(casting) }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="table-cell">{casting.pool_id} Casting</span>
                                    <span className="table-cell">{casting.model_count}</span>
                                    <span className="table-cell">placeholder</span>
                                </div>
                            ))}
                        </div>
                    </>
                )}
        </div>
    );
};

export default CastingUnit;
